import { useEffect, useState } from 'react';
import { dismissConflict, onSync, type SyncState } from '../offline/sync.js';
import { Icon, icons } from '../ui.js';

/** What the app says about a connection it does not have.
 *
 *  The voice rule holds here as everywhere: nothing is wrong, nothing is lost and
 *  nobody is being told off. Working offline is a normal thing to do, so the line
 *  describes the situation and stops. There is no count of unsent writes — how
 *  many is not a number anyone can act on, and it reads as a debt. */
export function SyncNotice() {
  const [s, setS] = useState<SyncState | null>(null);
  useEffect(() => onSync(setS), []);
  if (!s) return null;

  const line = !s.online
    ? s.waiting
      ? 'Offline — anything you change is kept here and goes out when you are back.'
      : 'Offline — showing what was here last.'
    : s.syncing && s.waiting
      ? 'Catching up…'
      : null;

  if (!line && !s.conflicts.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 14 }}>
      {line && (
        <div className="notice">
          <Icon path={s.online ? icons.repeat : icons.cloudOff} size={16} />
          <span>{line}</span>
        </div>
      )}
      {s.conflicts.map((c) => (
        <div className="notice notice-warm" key={c.id}>
          <Icon path={icons.info} size={16} />
          <span>
            {c.kind === 'delete'
              ? <>“{c.label}” had already changed here, so it was left as it is.</>
              : <>“{c.label}” changed while you were away, so that edit was left out.</>}
          </span>
          <button aria-label="Dismiss" onClick={() => dismissConflict(c.id)}
                  style={{ display: 'flex', opacity: .55, marginLeft: 'auto' }}>
            <Icon path={icons.x} size={13} w={2.4} />
          </button>
        </div>
      ))}
    </div>
  );
}
